import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { CepResponse } from '../interfaces/';
import { RequestsServices } from './requests.service';

@Injectable()
export class CEPServices {

constructor(private request: RequestsServices) { }

  getAddressByCep(cep: string): Observable<CepResponse> {
    return from(this.request.get({path: 'integration_viacep', pathParam: `/${cep}`}));
  }
}
